import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './y-com/Ycomjs'
import './assets/css/init.css'
import './assets/css/base.css'

import './assets/styles/reset.css'
import './assets/styles/border.css'
import './assets/styles/iconfont.css'
import './assets/styles/animate.css'

createApp(App).use(ElementPlus).use(store).use(router).mount('#app')
